import { render, staticRenderFns } from "./Medicalproduct.vue?vue&type=template&id=3e5d72a2&scoped=true"
import script from "./Medicalproduct.vue?vue&type=script&lang=js"
export * from "./Medicalproduct.vue?vue&type=script&lang=js"
import style0 from "./Medicalproduct.vue?vue&type=style&index=0&id=3e5d72a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d72a2",
  null
  
)

export default component.exports